import styled from 'styled-components';

import { applyDictionary } from '@belong/type-utils';

import { ITEM_CONTENT_TYPES } from '../lib/constants';
import CONTENT from './content.json';

const ChatEventWrapper = styled.div`
  text-align: center;
  font-style: italic;
  margin-bottom: 16px;
`;

const getEventText = (item: connect.ChatTranscriptItem) => {
  const isCustomerEvent = item.ParticipantRole === 'CUSTOMER';

  if (item.ContentType === ITEM_CONTENT_TYPES.JOINED) {
    return isCustomerEvent
      ? CONTENT.chat.customer.joined
      : applyDictionary({ displayName: item.DisplayName }, CONTENT.chat.agent.joined);
  }
  if (item.ContentType === ITEM_CONTENT_TYPES.LEFT) {
    return isCustomerEvent
      ? CONTENT.chat.customer.left
      : applyDictionary({ displayName: item.DisplayName }, CONTENT.chat.agent.left);
  }
  if (item.ContentType === ITEM_CONTENT_TYPES.ENDED) {
    return CONTENT.chat.ended;
  }
  return '';
};

type ChatEventProps = { item: connect.ChatTranscriptItem };

export const ChatEvent: React.FC<ChatEventProps> = ({ item }) => {
  return <ChatEventWrapper>{getEventText(item)}</ChatEventWrapper>;
};

ChatEvent.displayName = 'ChatEvent';
